import axios from "axios";
import { handleException} from "./handleException.js";
import { getCards, getCurrencies } from "./cards.js";
//
// Auth
//
export async function getAuthInfo(authToken) {
    try {
        const { data } = await axios.get(
            '/v2/wallet/auth/info',
            {
                "headers": {
                    "Authorization": "Token " + authToken
                },
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }

}


//
// Text data
//
export async function getTextData(authToken) {
    try {
        const { data } = await axios.get(
            '/v2/wallet/text-data/',
            {
                "headers": {
                    "Authorization": "Token " + authToken
                }
            }
        )
        const transformedData = {};
        data.results.forEach(item => {
            transformedData[item.iname] = item.text;
        });
        return transformedData
    } catch (error) {
        handleException(error)
        return {}
    }

}


//
// Register
//

export async function doRegister(registerData) {
    try {
        const { data } = await axios.post(
            '/v2/wallet/auth/register',
            registerData,
            {
                "validateStatus": status => (status >= 200 && status < 500)
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}

export async function doRegisterPhoneConfirm(phone, confirmCode) {
    try {
        const { data } = await axios.post(
            '/v2/wallet/auth/register/phone/confirm',
            {
                "phone": phone,
                "confirm_code": confirmCode,
            },
            {
                "validateStatus": status => (status >= 200 && status < 500)
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}


export async function doRegisterSetPin(authToken, pinCode) {
    try {
        const { data } = await axios.post(
            '/v2/wallet/auth/register/set/pin',
            {
                "pin_code": pinCode,
            },
            {
                "headers": {
                    "Authorization": "Token " + authToken,
                    "validateStatus": status => (status >= 200 && status < 500)
                }
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}


//
// Wallet
//
export async function getWalletList(authToken) {
    try {

        const { data } = await axios.get(
            '/v2/wallet',
            {
                "headers": {
                    "Authorization": "Token " + authToken
                }
            }
        );

        return data.results[0].accounts;
    } catch (error) {
        handleException(error)
        return {}
    }
}



//
// Walelt user notification
//
export async function getWalletUserNotifications(authToken) {
    try {
        const { data } = await axios.get(
            '/v2/wallet/user/notification',
            {
                "headers": {
                    "Authorization": "Token " + authToken
                }
            }
        );

        return data.results
    } catch (error) {
        handleException(error)
        return {}
    }
}



//
// Identification
//
export async function identificationLevelUpgrade(authToken) {
    try {
        const { data } = await axios.post(
            '/v2/wallet/identification-level/upgrade',
            {                
            },
            {
                "headers": {
                    "Authorization": "Token " + authToken
                },
                "validateStatus": status => (status >= 200 && status < 500)
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}

export async function identificationLevelStatus(authToken) {
    try {
        const { data } = await axios.post(
            '/v2/wallet/identification-level/status',
            {                
            },
            {
                "headers": {
                    "Authorization": "Token " + authToken
                },
                "validateStatus": status => (status >= 200 && status < 500)
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}


//
// Exchange
//
export async function getExchangeRates(authToken) {
    try {
        const { data } = await axios.post(
            '/v2/wallet/exchange/rates',
            {                
            },
            {
                "headers": {
                    "Authorization": "Token " + authToken
                },
                "validateStatus": status => (status >= 200 && status < 500)
            }
        )

        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}

export async function doExchange(authToken, from_account_id, to_account_id, from_amount, to_amount, rate_id) {
    try {

        const { data } = await axios.post(
            '/v2/wallet/exchange',
            {   
                'from_account_id': from_account_id,
                'to_account_id': to_account_id,
                'from_amount': from_amount,
                'to_amount': to_amount,
                'rate_id': rate_id,
            },
            {
                "headers": {
                    "Authorization": "Token " + authToken
                },
                "validateStatus": status => (status >= 200 && status < 500)
            }
        )
        return data
    } catch (error) {
        handleException(error)
        return {}
    }
}

export { getCards, getCurrencies }